const CollectionSyncMixin = {
  componentDidMount: function() {
    this.getBackboneCollections().forEach(function(collection) {
      collection.on('add remove change reset', this.forceUpdate.bind(this, null), this);
    }, this);
  },

  componentWillUnmount: function() {
    this.getBackboneCollections().forEach(function(collection) {
      collection.off(null, null, this);
    }, this);
  }
};

export default CollectionSyncMixin;
